import {store} from 'Store/store.index';
import {isMobile} from 'Utils/device';
import React, { lazy } from 'react'
import * as APP_CONSTANTS from 'Constants/app.constant';
import { convertController, fileController, preferenceFullScreenController } from "../Controllers/index";
import DrivesListDlg from 'Components/dialogs/DrivesListDlg/DrivesListDlg'
import PrivateDrives from 'Components/private_drives/PrivateDrives'
import OpenFile from 'Components/dialogs/OpenSaveCombine/Open/OpenFile'
import SaveFile from 'Components/dialogs/OpenSaveCombine/Save/SaveFile'
import Drives from 'Components/drives_panel/Drives'
import intl from 'react-intl-universal';
import { Modal } from 'antd';
import { observer, inject } from 'mobx-react'
import {
  SaveAsDialog,
  TrustManagerDialog,
  PreferencesDialog
} from '../../dialogs/index';
import {
  isJPDomain,
  colorToAARRGGBB
 } from 'Utils/utils';
import {
    OPEN_FILE_LOCAL,
    OPEN_FILE_FROM_URL,
    OPEN_FILE_FROM_GOOGLE_DRIVE,
    OPEN_FILE_FROM_ONE_DRIVE,
    OPEN_FILE_FROM_BOX,
    OPEN_FILE_FROM_DROPBOX,
    OPEN_FILE_FROM_DRIVES,
    OPEN_FILE_FROM_PRIVATE_DRIVE,
    OPEN_FILE_FROM_GET_START_GUID,
    OPEN_FILE_FROM_IMANAGE,
    OPEN_FILE_FROM_RECENT,
    OPEN_FILE_FROM_DOCUMENTS
  } from '../ui/constants/openfile.constants';
  import {
    SAVE_TO_LOCAL,
    SAVE_TO_DOWNLOAD,
    SAVE_TO_GOOGLE_DRIVE,
    SAVE_TO_ONE_DRIVE,
    SAVE_TO_BOX,
    SAVE_TO_DROPBOX,
    SAVE_TO_DRIVES,
    SAVE_TO_PRIVATE_DRIVE,
    SAVE_AS_FILE,
    SAVE_TO_FILE_CLASS,
    SAVE_TO_GOOGLE_DRIVE_CLASS,
    SAVE_TO_LOCAL_CLASS,
    SAVE_TO_ONE_DRIVE_CLASS,
    SAVE_TO_BOX_CLASS,
    SAVE_TO_DROPBOX_CLASS, SAVE_FILE_BTN_HIDDEN_SLOT, SAVE_TO_IMANAGE,
    SAVE_TO_FOXIT_STORAGE,
  } from '../ui/constants/savefile.constants';
  import {
    CONVERT_FILES_TO_PDF,
  } from "../ui/constants/convert.constants";
  import {GOOGLE_DRIVE, ONE_DRIVE, BOX, DROP_BOX, iManage, RECENT_BOX, DOCUMENT_BOX, FOXIT_STORAGE} from 'Api/drives.constants'
  import {
    FILE_TAB_TRUST_MANAGER,
    FILE_TAB_FILE_PREFERENCES,
    FILE_TAB_FILE_PROPERTIES,
    FILE_TAB_PDF_OPTIMIZER,
    FILE_TAB_PDF_REDUCE_SIZE,
    FILE_TAB_PDF_OPTIMIZER_SCANNED
  } from "../ui/constants/file.constants";
  import {
    DOCUMENT_LOADED,
    DOCUMENT_LOAD_FAILED,
    DOCUMENT_SAVED,
    //DOCUMENT_DURATION,
    //DOCUMENT_SAVE_FAILED,
  } from 'Components/viewer/ui/constants/event.constants';
import wrapDialog from '@/routes/wrapperDialog';
import autoBindReact from 'auto-bind/react';
import { DialogContainer } from '../EditorDialogsContainer';
import EditorContainer from '../EditorContainer';
import { COMMON_HEADER } from '@/constants/index'
import Shortcut from '../../../../foxitwebsdk/src/shared/Shortcut.js';

const PDFOptimizer=lazy(()=>import('Components/PDFOptimizer/PDFOptimizer'))
const ReduceFileSize=lazy(()=>import('Components/PDFOptimizer/Reduce/ReduceFileSize'))
const Scanned=lazy(()=>import('Components/PDFOptimizer/Scanned/Scanned'))
  type Props = {
    onClickCallback: any;
    containerCallbacks:any;
    isOpenFileForShare: boolean;
    updateIsOpenFileForShare: Function;
  };
  type State = {
    hasNewFileInput: boolean; 
    isShowDrivesListDlg: boolean;
    drivesListDlgType:string;
    driveName:string;
    driveOperateType:string;
    showDrives:boolean;
    saveFileActiveTabKey:number;
    isShowSaveFilePanel:boolean;
    drivesCustomInfo:any;
    isShowSaveAsDlg:boolean;
    openFileInfo:any;
    isShowPreferencesDlg:boolean;
    defaultActiveKey:any;
    messageDlgCfg:any;
    showParams:any;
    portfolioNodeDataForReduceFileSize:any;
  };

  const openOriginMap = {
    [ONE_DRIVE]: OPEN_FILE_FROM_ONE_DRIVE,
    [BOX]: OPEN_FILE_FROM_BOX,
    [DROP_BOX]: OPEN_FILE_FROM_DROPBOX,
    [GOOGLE_DRIVE]: OPEN_FILE_FROM_GOOGLE_DRIVE,
    [iManage]: OPEN_FILE_FROM_IMANAGE,
  }
  
@inject('appStore', 'driveStore', 'privateDriveStore', 'taskStore', 'userStore', 'collaborationStore')
@observer
export default class FileTab extends React.Component<Props, State> {

  pdfui: any;
  uiMgr:EditorContainer;
  inputFileRef: React.RefObject<any>;
  state: State ={hasNewFileInput:true, isShowDrivesListDlg:false, drivesListDlgType:'',
    driveName:'', driveOperateType:'', showDrives:false, saveFileActiveTabKey:0, isShowSaveFilePanel:false,
    drivesCustomInfo:null, isShowSaveAsDlg:false, openFileInfo:{},
    isShowPreferencesDlg:false, defaultActiveKey:null, messageDlgCfg:{},
    showParams:null,portfolioNodeDataForReduceFileSize:null
  };
  context:any;

    constructor(props) {
        super(props);
        autoBindReact(this);
        this.uiMgr = props.containerCallbacks

        this.inputFileRef = React.createRef();
        
        store.appStore.addAppEventListener(APP_CONSTANTS.SDK_FINISH_INIT, ()=>{
          this.pdfui = window.pdfui;
        });
        store.appStore.setOpenLocalFile(this.onClickFileInputToOpen)
        store.appStore.setSaveToLocalComputer(this.saveToLocalComputer)
    }

    componentDidMount(): void {
      const actions = {
        [OPEN_FILE_LOCAL]:() => {
          store.userStore.doSendGAEvent({ action: 'File_tab_open_local_file', label: 'file_tab', category: 'Foxit_Storage', eventKey: undefined, value: undefined });
          this.onClickFileInputToOpen();
        },
        [OPEN_FILE_FROM_DRIVES]:()=>this.onShowDrivesList({type: 'open'}),
        [OPEN_FILE_FROM_GET_START_GUID]:()=>this.commonForDrives('LOCAL_COMPUTER'),
        [SAVE_TO_DRIVES]:()=>this.onShowDrivesList({type: 'save'}),
        [OPEN_FILE_FROM_GOOGLE_DRIVE]: ()=>this.commonForDrives(GOOGLE_DRIVE),
        [OPEN_FILE_FROM_IMANAGE]:()=>this.commonForDrives(iManage),
        [OPEN_FILE_FROM_ONE_DRIVE]: ()=>this.commonForDrives(ONE_DRIVE),
        [OPEN_FILE_FROM_BOX]: ()=>this.commonForDrives(BOX),
        [OPEN_FILE_FROM_DROPBOX]: ()=>this.commonForDrives(DROP_BOX),
        [OPEN_FILE_FROM_PRIVATE_DRIVE]: fileController.openFilePrivateDrive,
        [SAVE_TO_LOCAL]: this.saveToLocalComputer,
        [SAVE_TO_DOWNLOAD]: this.saveToLocalComputer,
        [SAVE_AS_FILE]: ()=>this.onShowSaveAsDlg(SAVE_AS_FILE, null, null),
        [SAVE_TO_GOOGLE_DRIVE]: ()=>this.commonForSaveDrives(GOOGLE_DRIVE, null, 'pdf'),
        [SAVE_TO_ONE_DRIVE]:()=>this.commonForSaveDrives(ONE_DRIVE, null, 'pdf'),
        [SAVE_TO_BOX]:()=>this.commonForSaveDrives(BOX, null, 'pdf'),
        [SAVE_TO_DROPBOX]: ()=>this.commonForSaveDrives(DROP_BOX, null, 'pdf'),
        [SAVE_TO_IMANAGE]: () => this.commonForSaveDrives(iManage, null, 'pdf'),
        [SAVE_TO_PRIVATE_DRIVE]: ({newBtnName})=> {
          fileController.saveToPrivateDrive(
            newBtnName
          )
        },
        [FILE_TAB_PDF_OPTIMIZER]:this.onShowOptimizer,
        [FILE_TAB_PDF_REDUCE_SIZE]:this.onReduceFileSize,
        [FILE_TAB_PDF_OPTIMIZER_SCANNED]:this.onOptimizeScanned,
        [FILE_TAB_TRUST_MANAGER]:this.onShowTrustManagerDlg,
        [FILE_TAB_FILE_PREFERENCES]:()=>this.onShowPreferencesDlg(null),
        [OPEN_FILE_FROM_RECENT]: ()=>{
          store.userStore.doSendGAEvent({ action: 'File_tab_open_recent_file', label: 'file_tab', category: 'Foxit_Storage', eventKey: undefined, value: undefined });
          this.commonForDrives(RECENT_BOX)
        },
        [OPEN_FILE_FROM_DOCUMENTS]: ()=>{
          store.userStore.doSendGAEvent({ action: 'File_tab_open_documents', label: 'file_tab', category: 'Foxit_Storage', eventKey: undefined, value: undefined });
          this.commonForDrives(DOCUMENT_BOX)
        },
        [SAVE_TO_FOXIT_STORAGE]: () => {
          store.userStore.doSendGAEvent({ action: 'File_tab_save_to_foxit_storage', label: 'file_tab', category: 'Foxit_Storage', eventKey: undefined, value: undefined })
          this.commonForSaveDrives(FOXIT_STORAGE, null, 'pdf')
        },
      };
      const {setupViewerActionCallback} = this.props.containerCallbacks;
      Object.keys(actions).map(name => {
        setupViewerActionCallback(name, actions[name]);
      })

      Shortcut.register(document.body, 'ctrl+shift+s', (e) => {
        // Save As 
        e.preventDefault();
        const { headerType } = store.appStore;
        const pdfDocRender = store.viewer.pdfViewer.getPDFDocRender();
        if (headerType !== COMMON_HEADER || !pdfDocRender) return ;
        actions[SAVE_AS_FILE]();
      });

      const checkTimer = setInterval(() => {
        if (!window.pdfui) return;
        clearInterval(checkTimer);
        window.pdfui.eventEmitter.on('header-open-save-as', () => {
          this.onShowSaveAsDlg(SAVE_AS_FILE, null, null);
        });
      }, 1000);
    }

    onOptimizeScanned = (showParams)=>{
      this.uiMgr.setState({
        messageDlgCfg:{
            target:Scanned,
            config:{
                showParams,
                onCancel:() => this.uiMgr.setState({ messageDlgCfg: {} })
            }
        }
      });
    }

    onReduceFileSize = (portfolioNodeData, showParams) => {
      this.uiMgr.setState({
        messageDlgCfg:{
            target:ReduceFileSize,
            config:{
                showParams,
                portfolioNodeData,
                onCancel:() => this.uiMgr.setState({ messageDlgCfg: {} })
            }
        }
      });
    }

    onShowOptimizer = () =>{
      this.uiMgr.setState({
        messageDlgCfg:{
            target:PDFOptimizer,
            config:{
                onOk:this.onOkByOptimizer,
                onClose:this.onCloseByOptimizer,
                visible:true,
                onCancel:this.onCloseByOptimizer
            }
            }
      })
    }

    onOkByOptimizer = ({version, cfgOption})=>{
      store.taskStore.onUpdateTaskMessage({ status: 'task-step-begin-upload', ret: 0 }, 31);
      this.pdfui.getCurrentPDFDoc().then(pdfDoc => {
        return pdfDoc.optimizer(cfgOption);
      }).then(data => {
        this.onCloseByOptimizer();
        // download(data.buffer, data.fileName, 'application/octet-stream');
        convertController.doConvertPDFVersion(data, version * 10);
      });
    }
    onCloseByOptimizer = ()=>{
      this.uiMgr.setState({
        messageDlgCfg: {}
      })
    }

    onShowPreferencesDlg = async (defaultActiveKey)=>{
      if (!store.appStore.checkAppSignIn()) {
        return;
      }
      this.setState({
        isShowPreferencesDlg:true,
        defaultActiveKey:defaultActiveKey
      })
    }

    onCloseByPreferencesDlg=()=>{
      this.setState({
        isShowPreferencesDlg:false
      })
    }

    onOkByPreferencesDlg= ({formPreference, layoutPreference, searchPreference, commentPreference})=>{
      store.docStore.updateFormPreferenceAll(formPreference)
      store.docStore.undateLayoutPreferenceAll(layoutPreference)
      store.docStore.updateSearchPreferenceAll(searchPreference)
      store.docStore.updateCommentPreferenceAll(commentPreference)
  
      const {
        FieldsHightLight,
        // FieldsHightLight_argb,
        HighlightrRequiredFields,
        // HighlightrRequiredFields_argb,
        isAutomatically,
        isRectangle,
        // isOverflowIndicator,
        isHideDocumentMessage,
        isHighlight,
        // isNumericalData,
        isOpenPropertiesAfterCreating,
        // isRunFormRecognition,
        isAutoComplete,
        isRememberNumerical
      } = formPreference;
  
      window.pdfui.openFormPropertyBoxAfterCreated(isOpenPropertiesAfterCreating);
      window.pdfui.callAddonSync('SearchAddon', 'updateSearchPreference', [searchPreference])
  
      fileController.getPDFViewer().then(async viewer=>{
        viewer.highlightForm(isHighlight);//是否高亮表单
        viewer.setFormHighlightColor(colorToAARRGGBB(FieldsHightLight, 0.5), colorToAARRGGBB(HighlightrRequiredFields, 0.5));//设置表单背景色 字体色
        let doc = await window.pdfui.getCurrentPDFDoc();
        !!doc && viewer.setAutoCalculateFieldsFlag(isAutomatically);//是否自动计算
        !!doc && viewer.setFormFieldFocusRectangleVisible(isRectangle);
        viewer.setLayoutGridByStorageSettings();
        viewer.setSnapGridByStorageSettings();
        viewer.setAutoCompleteSetting({level:isAutoComplete,rememberNumericalData:isRememberNumerical});
        viewer.setUserConfig({commentPreference});
        // isRunFormRecognition && viewer.autoRecognitionForm();
        this.setState({
          isShowPreferencesDlg:false
        })
      })
  
      store.docStore.setIsHideDocumentMessage(isHideDocumentMessage);
    }

    onShowTrustManagerDlg =() =>{
      const {isEnableJS, isEnableSafeMode} = store.userStore;
      this.uiMgr.setState({
        messageDlgCfg:{
            target:TrustManagerDialog,
            config:{
                visible:true,
                isEnableJS,
                isEnableSafeMode,
                onOk: this.onOkByTrustManagerDlg,
                onClose: this.onCloseByTrustManagerDlg
            }
        }
      })
    }

    onOkByTrustManagerDlg=({isEnableJS, isEnableSafeMode})=>{

      fileController.getPDFViewer().then((viewer)=>{
        viewer.setEnableJS(isEnableJS);
        viewer.setSafeReadingMode && viewer.setSafeReadingMode(isEnableSafeMode);
      });
      store.userStore.setTrustConfig({
        isEnableJS, isEnableSafeMode
      })
      this.onCloseByTrustManagerDlg();
    }
  
    onCloseByTrustManagerDlg=()=>{
      this.uiMgr.setState({
        messageDlgCfg:{}})
    }

    onShowSaveAsDlg = (btnName, selectRect,graphicsObject) => {
      const {isDisableButton} = this.uiMgr;
      this.uiMgr.setState({
        messageDlgCfg:{
            target:SaveAsDialog,
            config:{
                btnName,
                selectRect,
                graphicsObject,
                showDrivesDialog: this.commonForSaveDrives,
                saveAsNormal: this.saveToLocalComputer.bind(this, { btnName }),
                visible:true,
                isDisableButton:isDisableButton,
                changeVisible:() => this.uiMgr.setState({messageDlgCfg:{}})
            }
        }
      })
    };

    onShowDrivesList = ({type}) => {
      const fn = ()=>{
        this.setState({
          isShowDrivesListDlg: true,
          drivesListDlgType: type,
        })
      }
      if(type === 'save'){
        fn()
        return;
      }
      window.onShowToSaveBeforeOpen((isToSave)=>{
        !isToSave && fn();
      })
    }

    onCancelDrivesListDlg = () => {
      this.setState({
        isShowDrivesListDlg: false,
        drivesListDlgType: '',
      })
    }
    commonForDrives = (activeKey) => {
      let fn = async ()=>{
        if(!isMobile){
          store.viewer._getPDFUI().then(async(pdfui) => {
            const button = await pdfui.getComponentByName(openOriginMap[activeKey])
  
            button && button.parent && button.parent.select(button)
          })
        }
  
        if (isMobile) {
          store.appStore.hideOpenFileDlg()
        } else {
          store.appStore.showOpenFileDlg(false, activeKey)
        }
  
        if (activeKey !== 'LOCAL_COMPUTER') {
          store.driveStore.setDriveName(activeKey)
        }

        this.setState({
          driveName: activeKey,
          driveOperateType: 'open',
          showDrives: isMobile?true:false,
        });
      }
  
      window.onShowToSaveBeforeOpen((isToSave)=>{
        !isToSave && fn();
      })
  
    }

    commonForDrivesInMobile = ({driveName, driveOperateType}) => {
      this.setState({
        driveName,
        driveOperateType,
        showDrives: true,
      });
    }
    
    commonForSaveDrives = (activeKey, customInfo, saveType) => {
      const hasOnlineSign = store.viewer.pdfViewer.getOnlineSignList().length;
      if(hasOnlineSign){
        store.viewer.pdfui.eventEmitter.emit('need-sign-tip', ()=> {this.commonForSaveDrives(activeKey, customInfo, saveType)});
        return;
      }

      if (!store.viewer.hasOpenFile) {
        return;
      }

      store.driveStore.updateSaveType(saveType)

      this.setState({
        saveFileActiveTabKey: activeKey,
        driveName: activeKey,
        driveOperateType: 'save',
        showDrives: !!isMobile,
        isShowSaveFilePanel: !isMobile,
        drivesCustomInfo: customInfo,
      });
    };

    onFinishSaveSuccess(){
      store.appStore.doUpdateDocModified(false, true);
      // ga
      store.userStore.doSendGAEvent({eventKey: DOCUMENT_SAVED, label:'doc_event', category:null, action:null, value:null})
    }

    onCloseOpenFilePanel(isCancel) {
      const isDownloadingFileGoogleDrive = store.driveStore.isDownloadFilePending(GOOGLE_DRIVE);
      const isDownloadingFileOneDrive = store.driveStore.isDownloadFilePending(ONE_DRIVE);
      const isDownloadingFileBox = store.driveStore.isDownloadFilePending(BOX);
      const isDownloadingFileDropBox = store.driveStore.isDownloadFilePending(DROP_BOX);
      const openFilePending = intl.formatMessage({ id: 'OpenFilePending' });
      const abandonOpenFile = intl.formatMessage({ id: 'AbandonOpenFile' });
  
      if (isDownloadingFileGoogleDrive || isDownloadingFileOneDrive || isDownloadingFileBox || isDownloadingFileDropBox) {
        Modal.confirm({
          title: openFilePending,
          content: abandonOpenFile,
          okText: intl.formatMessage({ id: 'Yes' }),
          cancelText: intl.formatMessage({ id: 'No' }),
          onOk: () => {
            store.driveStore.doCancelOpenFileRequest(GOOGLE_DRIVE);
            store.driveStore.doCancelOpenFileRequest(ONE_DRIVE);
            store.driveStore.doCancelOpenFileRequest(BOX);
            store.driveStore.doCancelOpenFileRequest(DROP_BOX);
            store.appStore.hideOpenFileDlg()
            isCancel && this.props.updateIsOpenFileForShare(false)
          },
        });
      } else {
        store.appStore.hideOpenFileDlg()
        isCancel && this.props.updateIsOpenFileForShare(false)
      }
    }

    onCloseSaveFilePanel = () => {
      const isUploadingFileGoogleDrive = store.driveStore.isUploadFilePending(GOOGLE_DRIVE);
      const isUploadingFileOneDrive = store.driveStore.isUploadFilePending(ONE_DRIVE);
      const isUploadingFileBox = store.driveStore.isUploadFilePending(BOX);
      const isUploadingFileDropBox = store.driveStore.isUploadFilePending(DROP_BOX);
      const isUpdatingFileGoogleDrive = store.driveStore.isUpdateFilePending(GOOGLE_DRIVE);
      const isUpdatingFileBox = store.driveStore.isUpdateFilePending(BOX);
      const existPendingRequest = intl.formatMessage({ id: 'SaveFilePending' });
      // const abandonRequest = intl.formatMessage({ id: 'AbandonSaveFile' });
  
      if (
        isUploadingFileGoogleDrive ||
        isUploadingFileOneDrive ||
        isUploadingFileBox ||
        isUploadingFileDropBox ||
        isUpdatingFileGoogleDrive ||
        isUpdatingFileBox
      ) {
        Modal.confirm({
          title: existPendingRequest,
          // content: abandonRequest,
          okText: intl.formatMessage({ id: 'Yes' }),
          cancelText: intl.formatMessage({ id: 'No' }),
          onOk: () => {
            store.driveStore.doCancelUploadFileRequest(GOOGLE_DRIVE);
            store.driveStore.doCancelUploadFileRequest(ONE_DRIVE);
            store.driveStore.doCancelUploadFileRequest(BOX);
            store.driveStore.doCancelUploadFileRequest(DROP_BOX);
  
            store.driveStore.doCancelUpdateFileRequest(GOOGLE_DRIVE);
            store.driveStore.doCancelUploadFileRequest(BOX);
  
            this.setState({
              isShowSaveFilePanel: false,
              drivesCustomInfo: null,
            });
          },
        });
      } else {
        this.setState({
          isShowSaveFilePanel: false,
          drivesCustomInfo: null,
        });
      }
      
      const openNewAfterSave = this.props.containerCallbacks.openNewFileAfterCloseResolve
      if (openNewAfterSave) {
        openNewAfterSave(true);
      }
    }

    saveToLocalComputer = (param, fileName) => {
      console.log("baocun 1")
      if (param) {
        const {btnName} = param;
        console.log("baocun 2")
        console.log(param)
        if(['save-to-local','save-as-file'].includes(btnName)){
          const hasOnlineSign = store.viewer.pdfViewer.getOnlineSignList().length;
          if(hasOnlineSign){
            store.viewer.pdfui.eventEmitter.emit('need-sign-tip', ()=> {this.saveToLocalComputer(param,fileName)});
            return;
          }
        }
      }

      if(!isJPDomain()){
        if (!store.appStore.checkAppSignIn()) {
          if(param && param.error){
            param.error()
          }
          return true;
        }
      }
      if (!store.viewer.hasOpenFile) {
        return;
      }
      //const env = getDownloadEnv();
      fileController.saveToLocalByNameAndEnv(fileName, null).then(() => {
        console.log("是否触发")
        this.onFinishSaveSuccess();
        this.onCloseSaveFilePanel();
        if(param && param.success){
          console.log("是否触发2")
          param.success()
        }
        setTimeout(() => {
          store.appStore.doUpdateDocModified(false);
        }, 600);
      }).catch(()=>{
        if(param && param.error){
          param.error()
        }
      });
    }

    onOpenFileForLocalComputer({file, fileName}) {
      store.docStore.setDocDriveName('')
      const fn = () => {
        const isShowShareDlg = () => {
          const { isOpenFileForShare } = this.props
  
          if (isOpenFileForShare) {
            store.collaborationStore.changeShareDialogState(true)
            this.props.updateIsOpenFileForShare(false)
          }
        }
        const isPossiblePDF = (file.type === 'application/pdf') || (file.type === '')
        if (isPossiblePDF) {
          window.pdfui
            .openPDFByFile(file, { fileName })
            .then(() => {
              isShowShareDlg()
            })
            .catch((/*e*/) => {});
        } else {
          convertController.doConvertToPDF(
            file,
            (result) => {
              if (result && result!='stop' && result.ret == 0 && result.url) {
                const { url, fileName } = result;
                fileController.doOpenFileByUrl(url, fileName, (/*err*/) => {}, false, () => {
                  isShowShareDlg()
                });
  
                return;
              }
            },
            (/*e*/) => {
              this.doCloseSidebar();
              //this.onErrorFromViewer(e, OPEN_FILE_LOCAL);
            },
            true
          );
        }
  
        this.onCloseOpenFilePanel(false);
      }
  
      if(!window.pdfui){
        store.viewer._getPDFUI().then(() => {
          fn()
        })
        return;
      }
  
      fn()
    }

    onOpenFileForUrl({url, fileName}) {
      fileController.doOpenFileByUrl(url, fileName, () => {
        this.onCloseOpenFilePanel(false);
      });
    }

    onOpenFile({blob, driveName, fileName, id, folderPath, item}){
      if(!window.pdfui){
        return;
      }
      //if(blob instanceof Blob) blob[name] = fileName;
  
      window.pdfui.openPDFByFile(blob, { fileName }).then(() => {
        this.setState({
          openFileInfo: {
            driveName,
            fileName,
            fileId: id,
            folderPath,
            item,
          },
        });
        store.driveStore.setIsOpenedFromDrive(true);
        store.privateDriveStore.setIsOpenedFromPrivateDrive(false);
      }).catch((/*e*/) => {});
    }

    onClickFileInputToOpen = ()=>{
        const { hasSignIn } = store.userStore;
        if(!hasSignIn && !isJPDomain()){
          store.appStore.doShowSignInDialog();
          return true;
        }
        const fn = async ()=>{
          const input = this.inputFileRef.current;
          if(!isMobile){
            let button = await this.pdfui.getComponentByName(OPEN_FILE_LOCAL)
            if(!button){
              const paddle=await this.pdfui.getComponentByName("fv--file-tab-paddle");
              await paddle.trigger('shown');
              button = await this.pdfui.getComponentByName(OPEN_FILE_LOCAL)
            }
            button.parent.select(button)
          }
    
          if(input){
            // to do click input
            input.click()
          }
        }
    
        if(!store.viewer.hasOpenFile || !store.appStore.docModified){
          fn()
          return;
        }
        // window.onShowToSaveBeforeOpen((isToSave)=>{
        store.appStore.onShowToSaveBeforeOpen((isToSave) => {
          !isToSave && store.appStore.doUpdateDocModified(false);
          // is true, do not open new file
          !isToSave && fn();
        })
    
      }

    onChangeByFileInput = (file)=>{

      const {onClickCallback} = this.props;
      const { doShowEditorLoading, onErrorFromViewer, isDisableButton} = this.uiMgr;
      window.pdfui.useIdleCallback(()=>{
        this.setState({
          hasNewFileInput:false
        },()=>{
          this.setState({hasNewFileInput:true});
        })
        onClickCallback();
      })
    
        file = file instanceof File? file: file.target.files[0];
          if (file.type === 'application/pdf') {
            store.docStore.setDocDriveName('');
            store.viewer.doOpenFile(file, (isLoading)=>{
              isLoading && doShowEditorLoading();
            })
              .catch((e) => {
                this.doCloseSidebar();
                onErrorFromViewer(e, OPEN_FILE_LOCAL);
              });
            // this.props.openFileCallback &&
            //   this.props.openFileCallback({ driveName: this.props.driveName, blob, id, fileName, folderPath: this.state.folderPath, item });
          } else {
            if(isDisableButton(CONVERT_FILES_TO_PDF) ){
              return;
            }
            convertController.doConvertToPDF(
              file,
              (result) => {
                if (result && result!='stop' && result.ret == 0 && result.url) {
                  const { url, fileName } = result;
                  store.docStore.setDocDriveName('');
                  fileController.doOpenFileByUrl(url, fileName, (/*err*/) => {
                  }, null, () => {});
    
                  return;
                }
              },
              (/*e*/) => {
                this.doCloseSidebar();
                //this.onErrorFromViewer(e, OPEN_FILE_LOCAL);
              },
              true
            );
          }
    
        // if(!store.viewer.hasOpenFile || !store.appStore.docModified){
        //   return;
        // }
      }
    
    doCloseSidebar = async () => {
        if (!this.pdfui) return;
        const sidebar = await this.pdfui.getComponentByName('sidebar');
        sidebar && sidebar.collapse();
      }

    onFinishSaveSuccessForPanelType = () => {
      store.appStore.doUpdateDocModified(false, true);
  
      this.setState({
        isShowSaveFilePanel: false,
        drivesCustomInfo: null,
      })
    }
      
    onCancelDriveModal() {
      this.setState({
        showDrives: false,
      });
    }

    onOpenPrivateDriveFile({driveName, blob, filePath, item}) {
      if(!window.pdfui){
        return;
      }
      //if(blob instanceof Blob) blob.name = item.name;
      store.privateDriveStore.setShowDrivesPanel(false);
      window.pdfui.openPDFByFile(blob, { fileName: item.name }).then(() => {
        let {selectedStorage} = store.privateDriveStore
  
        store.driveStore.setIsOpenedFromDrive(false);
        store.driveStore.setDriveName(driveName);
        store.privateDriveStore.setIsOpenedFromPrivateDrive(true);
        store.privateDriveStore.setFileOpenedFrom(selectedStorage);
        store.privateDriveStore.setOpenedFileInfo({ driveName, filePath, item });
      }).catch((/*e*/) => {
        //this.props.privateDriveStore.setShowDrivesPanel(false);
        this.uiMgr.showMsg({id:"Error.OpenFile"});
      });
    }

    render() 
    {
      const {isDisableButton} = this.uiMgr;
      const {messageDlgCfg, hasNewFileInput,isShowDrivesListDlg, isShowSaveAsDlg,isShowSaveFilePanel,openFileInfo,
          drivesListDlgType,showDrives, driveName, driveOperateType, drivesCustomInfo, isShowPreferencesDlg, 
          defaultActiveKey,
          } = this.state;
      const { openFileDlg: {isShow: isShowOpenFileDlg, activeMenuKey: openFileActiveTabKey}, showSaveAsDialogCNArea} = store.appStore;
      const {showDrivesPanel: showPrivateDrivesPanel} = store.privateDriveStore;
      const {isEnableJS, isEnableSafeMode} = store.userStore;
      return (
      <React.Fragment>
      {hasNewFileInput &&
        <input id='fo-file-input' ref={this.inputFileRef} type="file" accept={store.appStore.getSupportFileExtensions} style={{display:"none"}} onChange={this.onChangeByFileInput}/>
        }
      {!!isShowOpenFileDlg && <OpenFile activeKey={openFileActiveTabKey} onOpenFileForLocalComputer={this.onOpenFileForLocalComputer} onOpenFileForUrl={this.onOpenFileForUrl} openFileCallback={this.onOpenFile} onCancel={this.onCloseOpenFilePanel.bind(this, true)}/>}
      {!!isShowSaveFilePanel && <SaveFile onOpenFileForLocalComputer={this.onOpenFileForLocalComputer} onSaveToLocalComputer={this.saveToLocalComputer} onSaveAs={() => (this.setState({ isShowSaveFilePanel: false }), this.onShowSaveAsDlg(SAVE_AS_FILE,null,null))} saveSucceedCallback={this.onFinishSaveSuccessForPanelType} openFileInfo={openFileInfo} customInfo={drivesCustomInfo} activeKey={this.state.saveFileActiveTabKey} onCancel={this.onCloseSaveFilePanel} />}
      {// @ts-ignore
      showDrives && <Drives type="modal" driveName={driveName}  driverTitle={driveName} operateType={driveOperateType} visible={showDrives} openFileInfo={openFileInfo} customInfo={drivesCustomInfo} saveSucceedCallback={this.onFinishSaveSuccess} openFileCallback={this.onOpenFile} cancelModal={this.onCancelDriveModal} />}
      {!!isShowDrivesListDlg && <DrivesListDlg type={drivesListDlgType} onCancel={this.onCancelDrivesListDlg} onShowDriveDlg={this.commonForDrivesInMobile}/>}
        {showSaveAsDialogCNArea ? wrapDialog(<SaveAsDialog
          visible={true}
          isDisableButton={isDisableButton}
          changeVisible={value => store.appStore.toggleSaveAsDialogCNArea(value)}
          btnName={SAVE_AS_FILE}
          showDrivesDialog={this.commonForSaveDrives}
          saveAsNormal={this.saveToLocalComputer.bind(this, null)}
        />) : null
        }
      {// @ts-ignore
      !!showPrivateDrivesPanel && <PrivateDrives saveSucceedCallback={this.onFinishSaveSuccess} openFileCallback={this.onOpenPrivateDriveFile}/>}
      
      {// @ts-ignore
      !!isShowPreferencesDlg && <PreferencesDialog visible={isShowPreferencesDlg} {...{defaultActiveKey,onOk: this.onOkByPreferencesDlg,
        onClose: this.onCloseByPreferencesDlg,
        onSafeRead: this.onOkByTrustManagerDlg}}/>}
      </React.Fragment>
      )
    }
  
}
